import React from 'react';
import { motion } from 'framer-motion';
const phrases = ['El nudo en la garganta al despertar.', 'La humillación de escribir y ser ignorada.', 'El dedo temblando sobre el botón de enviar.', 'Revisar su última conexión como un ritual enfermo.', 'Prometer que no vas a mirar su perfil. Y fallar.', 'Sentir que perdiste el control de tu propia vida.'];
export function PainSection() {
  return <section className="py-5 px-6 bg-black border-t border-gold/10 pt-[30px] pb-[30px]" data-id="element-97">
      <div className="max-w-3xl mx-auto" data-id="element-98">
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="font-sans text-[10px] text-gold uppercase tracking-[0.3em] text-center mb-4" data-id="element-99">
          Si esto te suena familiar
        </motion.p>

        <div className="space-y-2" data-id="element-100">
          {phrases.map((phrase, i) => <motion.p key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: i * 0.1
        }} className="font-cinzel text-lg sm:text-xl md:text-2xl text-white/80 text-center leading-relaxed tracking-wide pt-[20px] pb-[20px]" data-id="element-101">
              {phrase}
            </motion.p>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="text-center mt-4" data-id="element-102">
          <p className="font-sans text-sm text-gray-500 font-light italic" data-id="element-103">
            No estás loca. Estás en abstinencia.
          </p>
        </motion.div>
      </div>
    </section>;
}